/** 客户端课文抽屉与服务端 AI 证据上下文共用的唯一正文来源。 */
export const AUTHORITATIVE_PASSAGE = [
  {
    id: "P01",
    chapterId: "chapter-1",
    text: "立春过后，大地渐渐从沉睡中苏醒过来。冰雪融化，草木萌发，各种花次第开放。再过两个月，燕子翩然归来。不久，布谷鸟也来了。于是转入炎热的夏季，这是植物孕育果实的时期。到了秋天，果实成熟，植物的叶子渐渐变黄，在秋风中簌簌地落下来。北雁南飞，活跃在田间草际的昆虫也都销声匿迹。到处呈现一片衰草连天的景象，准备迎接风雪载途的寒冬。在地球上温带和亚热带区域里，年年如是，周而复始。"
  },
  {
    id: "P02",
    chapterId: "chapter-1",
    text: "几千年来，劳动人民注意了草木荣枯、候鸟去来等自然现象同气候的关系，据以安排农事。杏花开了，就好像大自然在传语要赶快耕地；桃花开了，又好像在暗示要赶快种谷子。布谷鸟开始唱歌，劳动人民懂得它在唱什么：“阿公阿婆，割麦插禾。”这样看来，花香鸟语，草长莺飞，都是大自然的语言。"
  },
  {
    id: "P03",
    chapterId: "chapter-1",
    text: "这些自然现象，我国古代劳动人民称它为物候。物候知识在我国起源很早。古代流传下来的许多农谚就包含了丰富的物候知识。到了近代，利用物候知识来研究农业生产，已经发展为一门科学，就是物候学。物候学记录植物的生长荣枯、动物的养育往来，如桃花开、燕子来等自然现象，从而了解随着时节推移的气候变化和这种变化对动植物的影响。"
  },
  {
    id: "P04",
    chapterId: "chapter-2",
    text: "物候观测使用的是“活的仪器”，是活生生的生物。它比气象仪器复杂得多，灵敏得多。物候观测的数据反映气温、湿度等气候条件的综合，也反映气候条件对于生物的影响。应用在农事活动里，比较简便，容易掌握。物候对于农业的重要性就在这里。下面是一个例子。"
  },
  {
    id: "P05",
    chapterId: "chapter-2",
    text: "北京的物候记录，1962年的山桃、杏花、苹果、榆叶梅、西府海棠、丁香、刺槐的花期比1961年迟十天左右，比1960年迟五六天。根据这些物候观测资料，可以判断北京地区1962年农业季节来得较晚。而那年春初种的花生等作物仍然是按照往年日期播种的，结果受到低温的损害。如果能注意到物候延迟，选择适宜的播种日期，这种损失就可能避免。"
  },
  {
    id: "P06",
    chapterId: "chapter-3",
    text: "物候现象的来临决定于哪些因素呢？"
  },
  {
    id: "P07",
    chapterId: "chapter-3",
    text: "首先是纬度。越往北桃花开得越迟，候鸟也来得越晚。值得指出的是物候现象南北差异的日数因季节的差别而不同。我国大陆性气候显著，冬冷夏热。冬季南北温度悬殊，夏季却相差不大。在春天，早春跟晚春也不相同。如在早春三四月间，南京桃花要比北京早开二十天，但是到晚春五月初，南京刺槐开花只比北京早十天。所以在华北常感觉到春季短促，冬天结束，夏天就到了。"
  },
  {
    id: "P08",
    chapterId: "chapter-3",
    text: "经度的差异是影响物候的第二个因素。凡是近海的地方，比同纬度的内陆，冬天温和，春天反而寒冷。所以沿海地区的春天的来临比内陆要迟若干天。如大连纬度在北京以南约1°，但是在大连，连翘和榆叶梅的盛开都比北京要迟一个星期。又如济南苹果开花在四月中或谷雨节，烟台要到立夏。两地纬度相差无几，但烟台靠海，春天便来得迟了。"
  },
  {
    id: "P09",
    chapterId: "chapter-3",
    text: "影响物候的第三个因素是高下的差异。植物的抽青、开花等物候现象在春夏两季越往高处越迟，而到秋天乔木的落叶则越往高处越早。不过研究这个因素要考虑到特殊的情况。例如秋冬之交，天气晴朗的空中，在一定高度上气温反比低处高。这叫逆温层。由于冷空气比较重，在无风的夜晚，冷空气便向低处流。这种现象在山地秋冬两季，特别是这两季的早晨，极为显著，常会发现山脚有霜而山腰反无霜。在华南丘陵区把热带作物引种在山腰很成功，在山脚反不适宜，就是这个道理。"
  },
  {
    id: "P10",
    chapterId: "chapter-3",
    text: "此外，物候现象来临的迟早还有古今的差异。根据英国南部物候的一种长期记录，拿1741到1750年十年平均的春初七种乔木抽青和开花日期同1921到1930年十年的平均值相比较，可以看出后者比前者早九天。就是说，春天提前九天。"
  },
  {
    id: "P11",
    chapterId: "chapter-4",
    text: "物候学这门科学接近生物学中的生态学和气象学中的农业气象学。物候学的研究首先是为了预报农时，选择播种日期。此外还有多方面的意义。物候资料对于安排农作物区划，确定造林和采集树木种子的日期，很有参考价值，还可以利用来引种植物到物候条件相同的地区，也可以利用来避免或减轻害虫的侵害。我国有很大面积的山区土地可以耕种，而山区的气候、土壤对农作物的适应情况，有很多地方还有待调查。为了便利山区的农业发展，开展山区物候观测是必要的。"
  },
  {
    id: "P12",
    chapterId: "chapter-4",
    text: "物候学是关系到农业丰产的科学，我们要进一步加强物候观测，懂得大自然的语言，争取农业更大的丰收。"
  }
] as const;

export type AuthoritativePassageParagraph = (typeof AUTHORITATIVE_PASSAGE)[number];
export type AuthoritativePassageId = AuthoritativePassageParagraph["id"];

